import React, {Component, Fragment} from 'react';
import {connect} from "react-redux";
import windowSize from "../libs/reactWindowSize";

import ComponentRenderer from "./ComponentRenderer";
import {withScenePosition} from "../scenePosition";
import {withRouter} from "react-router-dom";


let getBackgroundImagePath = (filename) => {
  return `${window.public_url}/images/scenes/background-images/${filename}`
};

class Tabs extends Component {

  static getDerivedStateFromProps(props, state) {
    let currentTab = undefined;

    if(props.tab.indexes.size){
      currentTab = props.id === undefined ? props.tabs[0] : props.tabs[props.tab.indexes.get(props.id)];
    } else {
      currentTab = props.tabs.length ? props.tabs[0] : undefined;
    }

    if(!currentTab){
      return {
        ...state,
        image: undefined,
        components: undefined
      }
    }

    return {
      ...state,
      image: getBackgroundImagePath(currentTab.backgroundImage),
      components: currentTab.components
    }
  }

  componentDidMount() {
    this.props.dispatch({
      type: "tab/ACTIVATE_TAB",
      payload: {
        id: this.props.id,
        index: 0
      }
    });
  }

  render() {

    const {image, components} = this.state;
    const {id} = this.props;

    return (
      <Fragment>
        {image && components ?
          (<div className={`tabs`}
                data-id={id}
          >
            <img alt="tab background" src={image}/>
            {components ? <ComponentRenderer components={components}/> : null}
          </div>) : undefined}


      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    scene: state.scene,
    step: state.step,
    tab: state.tab
  }
}

Tabs.defaultProps = {
  selectedIndex: 0
}

export default withRouter(windowSize(connect(mapStateToProps)(withScenePosition(Tabs))));



// WEBPACK FOOTER //
// ./src/components/Tabs.jsx